import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import ButtonAction from 'src/components/Button.js/SaveButton';
import Loader from 'src/components/loader/loader';
import { Grid, TextField, Typography } from '@mui/material';

import { useCallback, useEffect, useRef, useState } from 'react';

import ChessBoardSelectCell from 'src/component-project/TableSelectedUser/ChessBoardSelectCell';
import ComboBox from 'src/components/Input/ComboBox';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import TextInput from 'src/components/Input/TextInput';

export default function TakeDevice({
    loading,
    visible = false,
    setVisible,
    data,
    idPermission = 1,
    callBackFunct = () => null,
    where = 'request',
}) {
    const { t } = useTranslation();
    const [flagProcess, setFlagProcess] = useState(false);
    const [noteChange, setNoteChange] = useState('');
    const [quantityChange, setQuantityChange] = useState('');
    const flagRef = useRef(false);

    const [dataDrawer, setDataDrawer] = useState([]);
    const [dataCell, setDataCell] = useState([]);
    const [selectDrawer, setSelectDrawer] = useState(0);
    const [selectedCell, setSelectedCell] = useState(null);
    const [selectCabinet, setSelectCabinet] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const isHandledRef = useRef(false);
    const [idRequestChange, setIdRequestChange] = useState(null);
    const cabinetAtAccount = glb_sv.getLocalStorageCabinet('cabinet');
    useEffect(() => {
        if (visible) {
            setSelectDrawer(0);
            setSelectedCell(null);
            setIdRequestChange(null);
            getItemChangeDevice();
        } else {
            clearIntervalCheckStatusCell();
        }
    }, [visible]);

    // useEffect(() => {
    //     try {
    //         setIsOpen(false);
    //         setDataDrawer([]);
    //         setDataCell([]);
    //         if (selectCabinet?.cabinet_id && visible) {
    //             isHandledRef.current = false;
    //             console.log(selectCabinet);
    //         }
    //     } catch (e) {}
    // }, [selectCabinet?.id]);

    // useEffect(() => {
    //     try {
    //         if (selectDrawer !== 0 && visible) {
    //             getAllCell(selectCabinet?.cabinet_id, selectDrawer);
    //         }

    //         if (selectDrawer === 0 && visible) {
    //             setDataCell([]);
    //         }
    //     } catch (e) {}
    // }, [selectDrawer, data?.id, visible]);

    useEffect(() => {
        return () => {
            clearIntervalCheckStatusCell();
        };
    }, []);

    const getItemChangeDevice = useCallback(() => {
        if (flagRef.current) return;
        flagRef.current = true;
        setFlagProcess(true);
        const InVal = [data];
        sendRequest(
            where === 'request' ? serviceList.getItemChangeDevice : serviceList.getItemChangeDeviceWithIdTransaction,
            InVal,
            getItemChangeDeviceResult,
            true,
            timeOutFunct,
            15000
        );
    }, [data]);

    const getItemChangeDeviceResult = (reqInfoMap, message) => {
        flagRef.current = false;
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows[0].o_1[0];
            setSelectDrawer(data?.drawer_id_take);
            setSelectedCell({
                cell_lc: data?.cell_lc_take,
                id: data?.cell_id_take,
                column: data?.column_take,
            });
            setQuantityChange(data?.qty);
            setNoteChange(data?.note);
            setIdRequestChange(data?.id);
            setSelectCabinet({
                cabinet_id: data?.cabinet_id_take,
                cabinet_cd: data?.cabinet_cd_take,
                cabinet_nm: data?.cabinet_nm_take,
                cabinet_type: data?.cabinet_type_take,
            });

            getDataDrawer(data?.cabinet_id_take);

            getAllCell(data?.cabinet_id_take, data?.drawer_id_take);
        }
    };

    const getDataDrawer = useCallback(
        (id) => {
            const InVal = [id];
            sendRequest(serviceList.getAlldrawerSp, InVal, getDataDrawerResult, true, timeOutFunct, 15000);
        },
        [visible, selectCabinet?.id]
    );

    const getDataDrawerResult = (reqInfoMap, message) => {
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const drawerData = [...message.proc_data.rows[0].o_1].filter((ele) => ele.block_status === '1');
            drawerData.map((ele) => {
                setDataDrawer((prev) => {
                    if (prev.some((item) => item.value === ele.id)) return prev;

                    return [
                        ...prev,
                        {
                            label: ele.drawer_nm,
                            value: ele.id,
                            lc: ele.drawer_lc,
                        },
                    ];
                });
            });
        }
    };

    const getAllCell = useCallback(
        (id_capinet, id_drawer) => {
            if (id_capinet && id_drawer) {
                const InVal = [idPermission, id_capinet, id_drawer];
                sendRequest(serviceList.getAllbox, InVal, getDataCellResult, true, timeOutFunct, 15000);
            }
        },
        [data, selectDrawer, selectCabinet]
    );

    const getDataCellResult = (reqInfoMap, message) => {
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataCell([...message.proc_data.rows[0].o_1]);
        }
    };
    // region send request grinding device
    const handleClick = useCallback(() => {
        if (isHandledRef.current) return;
        clearIntervalCheckStatusCell();
        setFlagProcess(true);
        isHandledRef.current = true;
        const InVal = [idRequestChange];
        sendRequest(serviceList.takeDeviceFromChangeDevice, InVal, actionResult, true, timeOutFunct, 60000);
        // actionResult("aaaa", {proc_status: 1, proc_message: "fininse"})
    }, [noteChange, data?.id, selectedCell?.id, quantityChange]);

    const actionResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            setFlagProcess(false);
            isHandledRef.current = false;
            return;
        } else {
            toast.success(message['proc_message']);
            closeCell();
        }
    };
    // region open cell
    const openCell = (data) => {
        if (selectCabinet?.cabinet_cd !== cabinetAtAccount?.cabinet_cd) {
            toast.error(t('select_right_cabinet'));
            return;
        }
        if (quantityChange > data?.qty) {
            toast.error(t('warning_qty_change_device'));
            return;
        }
        setFlagProcess(true);

        let service = serviceList.openCellIOT;
        const drawer_lc_select = dataDrawer.find((ele) => ele.value === (selectDrawer || data?.drawer_request_id))?.lc;
        let inpuVal = [
            selectCabinet?.cabinet_cd,
            drawer_lc_select,
            selectedCell.cell_lc.row,
            selectedCell.cell_lc.column,
        ];

        if (selectCabinet?.cabinet_type !== 'round') {
            service = serviceList.openCellIOT;
            inpuVal = [
                selectCabinet?.cabinet_cd || data.cabinet_cd,
                drawer_lc_select,
                selectedCell.cell_lc.row,
                selectedCell.cell_lc.column,
            ];
        } else {
            service = serviceList.openCellIOTCabinetV2;
            inpuVal = [
                selectCabinet?.cabinet_cd || data.cabinet_cd,
                drawer_lc_select,
                selectedCell.cell_lc.column,
                selectedCell.column,
            ];
        }
        // setFlagProcess(false);
        // setIsOpen(true);
        sendRequest(service, inpuVal, openCellResult, true, timeOutFunct, 30000, 0);
        // openCellResult('aaaa', 1);
    };

    const openCellResult = (reqInfoMap, message) => {
        console.log('reqInfoMap', reqInfoMap['input_param']);

        if ((message['proc_status']?.toString() || '0') === '0') {
            // closeCell();

            toast.error('Error: ' + message['proc_message']);
        } else {
            // isGivedevice ? handleActionGiveDevice() : handleActionDevice();
            setFlagProcess(false);
            setIsOpen(true);
            // if (data?.status === '0') adminGet(data?.id);
            // gọi api kiểm tra trạng thái ô sau 5s
            const input_param = reqInfoMap['input_param'];
            // setTimeout(() => {
            handleIntervalCheckStatusCell(input_param[0], input_param[1], input_param[2]);
            // }, 5000);
        }
    };

    // region closeCell
    const closeCell = () => {
        let service = serviceList.closeCellIOT;
        clearIntervalCheckStatusCell();
        const drawer_lc_select = dataDrawer.find((ele) => ele.value === ele.id)?.lc;
        let inpuVal = [
            selectCabinet?.cabinet_cd,
            drawer_lc_select,
            selectedCell.cell_lc.row,
            selectedCell.cell_lc.column,
        ];
        if (selectCabinet?.cabinet_type !== 'round') {
            service = serviceList.closeCellIOT;
            inpuVal = [
                selectCabinet?.cabinet_cd,
                drawer_lc_select,
                selectedCell.cell_lc.row,
                selectedCell.cell_lc.column,
            ];
        } else {
            service = serviceList.closeCellIOTCabinetV2;
            inpuVal = [selectCabinet?.cabinet_cd, drawer_lc_select, selectedCell.cell_lc.row, selectedCell.column];
        }
        sendRequest(service, inpuVal, closeCellResult, true, timeOutFunct, 30000, 0);
        // console.log('inpuValClose: ', inpuVal);
        // console.log('serviceListClose: ', service);
    };

    // region closeCellResult
    const closeCellResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            setIsOpen(false);
            setFlagProcess(false);
            callBackFunct && callBackFunct();
            isHandledRef.current = false;
        }
        clearIntervalCheckStatusCell();
    };

    // region checkStatusCell START
    const checkIntervalCheckStatusCell = useRef(null);
    const checkStatusCellFlag = useRef(false);
    const handleIntervalCheckStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        checkIntervalCheckStatusCell.current = setInterval(() => {
            checkStatusCell(cabinet_cd, drawer_id, cell_address);
        }, 3000);
    };
    const clearIntervalCheckStatusCell = () => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        clearInterval(checkIntervalCheckStatusCell.current);
        checkIntervalCheckStatusCell.current = null;
        checkStatusCellFlag.current = false;
    };
    const checkStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        if (!cabinet_cd || !drawer_id || !cell_address || checkStatusCellFlag.current) return;
        checkStatusCellFlag.current = true;
        const inpuVal = [cabinet_cd, drawer_id, cell_address];
        sendRequest(
            serviceList.checkStatusCell,
            inpuVal,
            checkStatusCellResult,
            true,
            checkStatusCellTimeOut,
            10000,
            0
        );
    };
    const checkStatusCellResult = (reqInfoMap, message) => {
        checkStatusCellFlag.current = false;
        console.log(
            'checkStatusCellResult',
            (message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1'
        );
        if ((message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1') {
            clearIntervalCheckStatusCell();
            if (!isHandledRef.current || !flagProcess) {
                handleClick();
            }
        }
    };
    const checkStatusCellTimeOut = (reqInfo) => {
        checkStatusCellFlag.current = false;
        setFlagProcess(false);
        toast.error(t('error.request_timeout'));
    };

    const timeOutFunct = (reqInfo) => {
        flagRef.current = false;
        setFlagProcess(false);
        toast.error(t('error.time_out'));
        setVisible(false);
        setSelectDrawer(null);
        setSelectedCell(null);
        callBackFunct();
    };
    return (
        <div>
            <Dialog
                open={visible}
                onClose={() => {
                    setVisible(false);
                    setSelectDrawer(null);
                    setSelectedCell(null);
                    setIdRequestChange(null);
                }}
                aria-labelledby="customized-dialog-title"
            >
                <Loader loading={loading || flagProcess || flagRef.current} />
                <DialogTitle style={{ cursor: 'move' }} id="customized-dialog-title">
                    {t('title_popup_take_device_want_change')}
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            style={{ width: '100%', gap: 10, display: 'flex', flexDirection: 'column', minWidth: 350 }}
                            xl={12}
                            md={12}
                            sm={12}
                        >
                            {/* <DialogContentText>{mesages ? t(mesages) : t('message')}</DialogContentText> */}
                            <TextField
                                label={t('note_change_device')}
                                value={noteChange}
                                size="medium"
                                required
                                onChange={(ele) => setNoteChange(ele.currentTarget.value)}
                                disabled
                            />
                            <TextField
                                label={t('amount')}
                                value={quantityChange}
                                size="medium"
                                type="number"
                                required
                                onChange={(ele) => setQuantityChange(ele.currentTarget.value)}
                                disabled
                            />
                        </Grid>

                        <Grid item xl={12} md={12} sm={12} style={{ width: '100%', marginTop: 7 }}>
                            <TextInput
                                label={t('choose_cabinet')}
                                valueChange={selectCabinet?.cabinet_nm}
                                disabled
                                size="medium"
                            />
                        </Grid>

                        <Grid item xl={12} md={12} sm={12} style={{ width: '100%', marginTop: 7 }}>
                            <ComboBox
                                label={t('choose_drawer')}
                                sizeCbb="medium"
                                displayLabel="label"
                                valueSelect={dataDrawer.find((ele) => ele.value === selectDrawer)}
                                valueEqual="value"
                                getValue={(e) => setSelectDrawer(e?.value || 0)}
                                selectOption={dataDrawer}
                                required
                                disabled
                            />
                        </Grid>

                        {dataCell.length > 0 && (
                            <>
                                <Typography variant="h5" sx={{ mt: 2, textAlign: 'center', width: '100%' }}>
                                    {t('select_device_the_cell_noti')}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        textAlign: 'center',
                                        display: 'block',
                                        fontStyle: 'italic',
                                        width: '100%',
                                        color: '#adb1b5',
                                    }}
                                >
                                    {t('warning_cell_have_device')}
                                </Typography>
                                <ChessBoardSelectCell
                                    typeCabinet={selectCabinet?.cabinet_type}
                                    cell_id_request={selectedCell}
                                    onSelect={(pos) => {
                                        // if (data?.status === '0') {
                                        // setSelectedCell(pos);
                                        // }
                                    }}
                                    dataCell={dataCell}
                                    selectedCell={selectedCell}
                                />
                            </>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions style={{ padding: '12px 16px' }}>
                    <ButtonAction
                        title={t('cancel')}
                        onClick={() => setVisible(false)}
                        // variant="text"
                        color="error"
                        type="cancel"
                    />
                    {!isOpen ? (
                        <ButtonAction
                            onClick={() => openCell(data)}
                            // onClick={() => {
                            //     handleClick();
                            // }}
                            disabled={
                                !noteChange ||
                                !quantityChange ||
                                !selectCabinet?.cabinet_id ||
                                !selectDrawer ||
                                !selectedCell
                            }
                            type="confirm"
                            icon="send"
                            title={t('open_cell_output')}
                        />
                    ) : (
                        <ButtonAction
                            onClick={() => {
                                handleClick();
                            }}
                            type={'confirm'}
                            icon="send"
                            title={t('confrim_success')}
                        />
                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
}
